import { createSelector } from 'reselect';

export const planNameSelector = createSelector(
    state => {
        return state.planNameReducer },
    ({ planName }) => planName,
);
